<ng-container *ngIf="! hasError">
  <ng-content></ng-content>
</ng-container>
<ng-container *ngIf="hasError">
  <div [align]="alignment">
    <span
      data-testid="error_forbidden"
      *ngIf="isForbiddenHttpError"
      [class.for-widget]="displayAs === 'widget'"
    >
      <ng-container *ngIf="message | blank">
        {{ (isAction ? 'forbidden_action_error' : 'forbidden_error') | translate }}
      </ng-container>

      <ng-container *ngIf="message | filled">
        {{ message | translate }}
      </ng-container>
    </span>
  </div>
</ng-container>